import React, { useEffect, useState } from 'react'
import isNull from '../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Modal } from "react-bootstrap";
import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { useSelector } from 'react-redux';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';

const StatusData = [
  { display: '', value: '' },
  { display: 'Active', value: 'Active' },
  { display: 'In Active', value: 'In Active' },
];
const AddNewGoals = (props) => {
  const { isOpenGoals, onClose, onDeleteGoals } = { ...props }
  let { patientID, IsEditAllowed } = props;
  // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true)).data?.id;
  const API_URL = enumUtil.controller.General
  let Goals_Modal = {
    Goal: "",
    OnSetDate: "",
    GoalStatus: "",
  }
  let valModal = {}
  let ValidationModal = {
    GoalVal: "",
    OnSetDateVal: "",
    GoalStatusVal: "",
  }
  const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
  const [goalID, setGoalID] = useState();
  const [goalsValidationModal, setGoalsValidationModal] = useState(ValidationModal)
  const [goalsSaveUpdateModal, setGoalsSaveUpdateModal] = useState({})
  const [mainGoalsModal, setMainGoalsModal] = useState(Goals_Modal);
  const [isLoading, setIsLoading] = useState(false)
  const [onGoalsSaved, setOnGoalsSaved] = useState(false)
  const [del, setDel] = useState(false)
  const [searchDropdown, setSearchDropdown] = useState(false);
  const [is, setIs] = useState(false);
  console.log("AddNewProblem", props)

  useEffect(() => {
    // setPracticeID(PracticeID)
    if (props.goalID != null) {
      setDel(true)
      setGoalID(props.goalID)
    } else {
      if (!onGoalsSaved) {
        setGoalID("0");
        setDel(false)
      } else {
        setDel(true)
      }
    }
    if (!isNull(goalID)) {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "ID": goalID,
        "TableName": enumUtil.enumAPITableName.PatientGoal
      }).then((response) => {
        setIsLoading(false)
        setIs(true)
        setMainGoalsModal(response)
      }).catch((error) => {
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        setIsLoading(false)
      })
    }
  }, [goalID])

  const GoalsValidation = async () => {

    let ValidationModal = {
      GoalVal: FormValidator(
        mainGoalsModal.Goal,
        enumUtil.enumValidationType.Required,
        'Goal Name',
      ),
      OnSetDateVal: FormValidator(
        mainGoalsModal.OnSetDate,
        enumUtil.enumValidationType.Required,
        'OnSetDate',
      ),
      GoalStatusVal: FormValidator(
        mainGoalsModal.GoalStatus,
        enumUtil.enumValidationType.Required,
        'Status',
      ),
    }
    await setGoalsValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  const handleSaveGoal = async (type) => {
    if(!IsEditAllowed) return;
    await GoalsValidation()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      setGoalsSaveUpdateModal(goalsSaveUpdateModal)
      let saveModal = {
        TableName: enumUtil.enumAPITableName.PatientGoal,
        ID: String(goalID),
        Data: { PatientID: patientID, ...goalsSaveUpdateModal },
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
            props?.setIsRecordSaved(true);
            setGoalID(response.id)
            if (type === "Add Another") {
              addNewGoal();
            } else {
              onClose();
            }
          }
        }).catch((error) => {
          setIsLoading(false)
          console.log('error', error);
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
  }

  const addNewGoal = () => {
    props.setGoalID(null);
    setGoalID(null)
    handleClear();
  }
  const handleClear = () => {
    setMainGoalsModal(Goals_Modal);
    setGoalsSaveUpdateModal({});
  }

  const handleChange = (e) => {
    let { name, value } = e.target
    let modal = { ...mainGoalsModal };
    let saveModal = { ...goalsSaveUpdateModal }
    modal[name] = value
    setMainGoalsModal(modal)
    for (var property in Goals_Modal) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setGoalsSaveUpdateModal(saveModal)
  }
  const handleDateChange = (date, type) => {
    var FormatedDate = date
    let modal = { ...mainGoalsModal };
    let saveModal = { ...goalsSaveUpdateModal }
    modal[type] = FormatedDate
    setMainGoalsModal(modal)
    for (var property in Goals_Modal) {
      if (type === property) {
        saveModal[type] = FormatedDate
      }
    }
    setGoalsSaveUpdateModal(saveModal)
  }

  const GoalsName = () => {
    return (
      <p className="heading">Add New Goal</p>
    )
  }
  const handleSelectedData = (selectedData, name, type, mode) => {
    setIs(true)
    let modal = { ...mainGoalsModal };
    if (type === 'client' && !isNull(selectedData)) {
      if (name === "GoalStatus") {
        modal[name] = selectedData.display
        goalsSaveUpdateModal[name] = selectedData.value + "";
        // setProviderID(selectedData.value + "")
      } else if (name === "ProviderID") {
        modal[name] = selectedData.display
        goalsSaveUpdateModal[name] = selectedData.value + "";
        // setProviderID(selectedData.value + "")
      }
    } else if (type === 'server' && !isNull(selectedData)) {
      // if (name === 'POSCode') {
      //     LocationSaveUpdateModal[name] = selectedData.ID
      //     setPOS(selectedData.ID)


    } else {

      modal[name] = ''
      goalsSaveUpdateModal[name] = ''
    }
    setMainGoalsModal(modal)
    return selectedData
  }

  const handleDeleteModal = () => {
    setisOpenDeleteAlert(true)
  }
  const onCloseDelete = () => {
    setisOpenDeleteAlert(false);
  }
  const onDelete = () => {
    props?.setIsRecordSaved(true);
    setisOpenDeleteAlert(false);
    onClose();
  }

  let DeleteConfirmation = "";
  if (isOpenDeleteAlert) {
    DeleteConfirmation = (
      <DeleteConfirmatiom
        isOpenAlert={isOpenDeleteAlert}
        hideReason={true}
        API_URL={API_URL}
        TableName={enumUtil.enumAPITableName.PatientGoal}
        ID={String(goalID)}
        onCloseDelete={onCloseDelete}
        onClose={onDelete}
      />
    );
  }
  let DeletePopup = "";
  if (del) {
    DeletePopup = (
      <button
        className={
          props?.IsDeleteAllowed
            ? 
          "btn-icon-transparent"
            : 
            "btn-icon-transparent delete-btn-disabled"
        } onClick={handleDeleteModal}>
        <span className="icon"><i className="icon-delete"></i></span>
        <span className="title">Delete</span>
      </button>
    );
  }

  return (
    <Modal show={isOpenGoals} onHide={isOpenGoals} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
      <Modal.Body>
        {DeleteConfirmation}
        {isLoading ? <Loader /> : <></>}
        <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={GoalsName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
        <div className="">
          <div className='patient_payment_tabs'>
            {/* <div className="input"> */}
            <div className={`input ${goalsValidationModal.GoalVal ? 'error' : ''}`}>
              <label className="pb-3px">Goal</label>
              <textarea rows="3" className="form-control"
                id='Goal'
                name='Goal'
                onChange={handleChange}
                value={mainGoalsModal.Goal} />
              {goalsValidationModal.GoalVal}
            </div>
            <div className="d-flex align-items-end gap-12 mb-12">
              <div className="input mb-0">
                <DatePicker
                  label="Onset Date"
                  className={goalsValidationModal.OnSetDateVal ? 'mb-0 error' : ''}
                  value={mainGoalsModal.OnSetDate}
                  handleCalendarChangefunc={date => handleDateChange(date, 'OnSetDate')} />
              </div>
              <div className="form-group input">
                <div className={`input form-group ar-multiple-br m-0 ${goalsValidationModal.GoalStatusVal ? 'error' : ''}`}>
                  <label className="pb-3px">Status</label>
                  <SuperSearchList
                    type="client"
                    id='GoalStatus'
                    name='GoalStatus'
                    searchValue={mainGoalsModal.GoalStatus}
                    data={StatusData}
                    onChange={handleChange}
                    getSelectedData={handleSelectedData}
                    is={is}
                    sup_btn='sup_btn-Inp'
                    sup_inp='superSearchVisitInp'
                    placeholder="Select Status"
                    inputError={goalsValidationModal.GoalStatusVal}
                  />
                  {goalsValidationModal.GoalStatusVal}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      
      <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
        <div className="d-flex align-items-center gap-2">
          <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`}  onClick={() => handleSaveGoal("Add Another")}>Save & Add Another</button>
          <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`}  onClick={handleSaveGoal}>Save</button>
        </div>
      </div>
    </Modal>
  )
}

export default AddNewGoals